var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.input)?_c('app-form',{ref:"appForm",attrs:{"form-class":"pa-0 pb-0","model":_vm.model,"inputs":[_vm.input],"button":false},on:{"change":_vm.onChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }